import ArrowSquareUpBold from './ArrowSquareUpBold';

export default ArrowSquareUpBold;
